import React, { useEffect, useState } from "react";
// import data from "../Pages/Fact_List/TablesData.json";
import { Table, Badge } from "antd";
import { Card, CardBody } from "reactstrap";
import Axios from "axios";
import { baseUrl } from "../../Controllers/rest_api_config";
import RangePickerEvents from "./RangePicker";
import {uid} from "uid"
import { error } from "../../Controllers/toast";
import { useSelector } from "react-redux";
import moment from "moment-jalaali";

const checkStatusColor = (status) => {
  if (status >= 200 && status < 300) return "green";
  if (status >= 300 && status < 400) return "red";
  if (status >= 400 && status < 500) return "orange";
  else return "blue";
};
const checkStatusText = (status) => {
  switch (status) {
    case "stable":
      return "فعال";
    case "unstable":
      return "غیرفعال";
    case "unknown":
      return "نامشخص";
    default:
      return "درحال برررسی";
  }
};
// Child Table Start
const AlertTable = (props) => {
  const { data, plantsTable } = props;
  const lang_choiced = useSelector((state) => state.lang_change);


  const columns = [
    {
      title: lang_choiced.pages.events.table.StringManager.index,
      render: (text, record, index) => index+1,
    },
    {
      title: lang_choiced.pages.events.table.StringManager.serial_number,
      dataIndex: "",
      width: "10%",
      render:(text, record, index)=>record.Power_Optimizer?record.Power_Optimizer.serial_number:record.Gateway_Devices.serial_number
    },
    {
      title: lang_choiced.pages.events.table.StringManager.event_time,
      dataIndex: "event_time",
      render: (text, record, index) => {
        const date = new Date(parseInt(text));
        return moment(date).format("jYYYY/jMM/jDD HH:mm:ss"); // خروجی شمسی
      },      
      width: "15%",
      className:"ltr"
    },
    {
      title: lang_choiced.pages.events.table.StringManager.event_code,
      dataIndex: "event_code",
    
    },

    {
      title: lang_choiced.pages.events.table.StringManager.event_title,
      dataIndex: "Event_Description",
      render: (text, record, index) => text.title,
      width: "15%",
    },
    {
      title: lang_choiced.pages.events.table.StringManager.event_description,
      // dataIndex: "",
      render: (text) => (
        <span>
          {text.Event_Description.content}
          {text.description ? ` (${text.description})` : ""}
        </span>
      ),
      width: "55%",
    },
  ];


  const plantsTableColumn = [
    {
      title: lang_choiced.pages.events.table.UPV.index,
      render: (text, record, index) => index,
    },
    {
      title: lang_choiced.pages.events.table.UPV.event_time,
      dataIndex: "event_time",
      render: (text, record, index) =>
        {
          console.log(text)
          return moment(new Date(parseInt(text)), "jYYYY/jMM/jDD HH:mm:ss").format("YYYY/MM/DD HH:mm:ss")},
      width: "10%",
      className:"ltr"
    },
    {
      title: lang_choiced.pages.events.table.UPV.event_code,
      dataIndex: "event_code",
     
    },

    {
      title: lang_choiced.pages.events.table.UPV.event_title,
      dataIndex: "Event_Description",
      render: (text, record, index) => text.title,
      width: "15%",
    },
    {
      title: lang_choiced.pages.events.table.UPV.event_description,
      // dataIndex: "",
      render: (text) => (
        <span>
          {text.Event_Description.content}
          {text.description ? ` (${text.description})` : ""}
        </span>
      ),
      width: "55%",
    },
  ];
  // console.log(props.total, "is toatal");
  // const [tableData, setData] = useState([]);

  // console.log(props.date, "is date props");
  if (props.EventsPage === true) {
    return (
      <div>
        <Table
          pagination={{
            // pageSize: props.EventsPage === true ? 10 : 5,
            position: ["bottomCenter"],
            total: props.total !== null ? props.total : 0,
          }}
          columns={plantsTable ? plantsTableColumn : columns}
          dataSource={props.data}
          scroll={{ x: 1500 }}
          loading={props.loading}
          rowKey={(record) => record.event_time*Math.random()}
          onChange={(page, pageSize) => {
            // console.log(page)
            if (props.EventsPage === true) {
           
              // props.refetch({skip:page.current})
            }
          }}
        />
      </div>
    );
  } else {
    return (
      <Table
        pagination={{ pageSize: 5, position: ["bottomCenter"] }}
        columns={plantsTable ? plantsTableColumn : columns}
        dataSource={props.data}
        scroll={{ x: 1500 }}
        rowKey={() => uid()}
      />
    );
  }
};
export default AlertTable;
